import {
  DialogContent,
  Dialog,
  DialogProps,
  DialogActions,
  useTheme,
  useMediaQuery,
  Grid,
} from '@mui/material';
import { styled } from '@mui/styles';
import { PmiButton } from 'shell/components/shared/button';
import { memo } from 'react';
import {
  TipoOccupazioneLegittima,
  TipoOccupazioneLegittimaFamigliaEsistente,
} from 'practice/constants/house-occupation';
import { TypeRegister } from 'practice/constants/type-register';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)((props) => ({
  '& .MuiDialog-paper': props.fullScreen
    ? {}
    : {
        minWidth: '50rem',
        maxWidth: '800px',
      },
}));

interface ModalDigitalManuelProps {
  open: boolean;
  onClose: () => void;
  onManual: () => void;
  onDigital: () => void;
  onUnsolicitedNotification: () => void;
  tipoRegistro: string | undefined;
  occupanteLegittimo: string | null;
}

const ModalDigitalManuelComponent = ({
  open,
  onClose,
  onManual,
  onDigital,
  onUnsolicitedNotification,
  tipoRegistro,
  occupanteLegittimo,
}: ModalDigitalManuelProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.sm));
  const text = 'Si vuole procedere con la notifica manuale o digitale (Send)?';

  const notificaNonRichiesta =
    (tipoRegistro === TypeRegister.Immigration || tipoRegistro === TypeRegister.Residence) &&
    (occupanteLegittimo === TipoOccupazioneLegittima.AutorizzatoERP ||
      occupanteLegittimo === TipoOccupazioneLegittima.OspiteIntestatarioERP ||
      occupanteLegittimo === TipoOccupazioneLegittimaFamigliaEsistente.AutorizzatoERP ||
      occupanteLegittimo === TipoOccupazioneLegittimaFamigliaEsistente.OspiteIntestatarioERP);

  return (
    <PmiDialog
      open={open}
      fullScreen={fullScreen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent style={{ padding: '30px 24px' }}>
        <Grid container spacing={2}>
          {text}
        </Grid>
      </DialogContent>
      <DialogActions>
        <PmiButton variant="contained" color="primary" onClick={() => onManual()}>
          Notifica manuale
        </PmiButton>
        <PmiButton variant="contained" color="primary" onClick={() => onDigital()}>
          Notifica digitale
        </PmiButton>
        {notificaNonRichiesta ? (
          <PmiButton
            variant="outlined"
            color="cdmBrand"
            onClick={() => onUnsolicitedNotification()}
          >
            Notifica non richiesta
          </PmiButton>
        ) : undefined}

        <PmiButton
          variant="outlined"
          color="cdmBrand"
          onClick={() => {
            onClose();
          }}
        >
          Annulla
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ModalDigitalManuelComponent.displayName = 'Modal Digital Manuel component';

const ModalDigitalManuel = memo(ModalDigitalManuelComponent);

export default ModalDigitalManuel;
